import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import Resizer from 'react-image-file-resizer';

const resizeFile = (file: Blob, callback: Function) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      500,
      500,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
        if (uri instanceof Blob) {
          callback(uri)
        }
      },
      "blob"
    );
  });

export const readImageInput = async (input: HTMLInputElement, getFile: Function, successCallback: Function) => {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    try {
      await resizeFile(input.files[0], successCallback);
    } catch (err) {
    }

    reader.onloadend = function (e) {
      getFile(e.target?.result);

    }

    reader.readAsDataURL(input.files[0]); // convert to base64 string
  }
}

export const PhotoUploader = ({ setUploadPhoto, clearPhoto, uploadText }: { setUploadPhoto: (photo: Blob) => void, clearPhoto?: boolean, uploadText?: string }) => {
  const [currentPhoto, setCurrentPhoto] = useState(null);
  const uploadInput = useRef(null);
  useEffect(() => {
    if (clearPhoto) {
      setCurrentPhoto(null);
      // clear input
      (uploadInput.current as any).value = '';

    }
  }, [clearPhoto])

  return (
    <React.Fragment>
      <div id="uploader" onClick={() => (document as any).getElementById('upload-input').click()} className=" h-100 rounded border align-items-center d-flex flex-row">
        <div id="upload-preview" className="text-center m-auto">
          {currentPhoto ?
            <div className='m-2 overflow-hidden rounded'><img className='w-100' style={{ maxWidth: '250px', maxHeight: '250px' }} src={currentPhoto} alt="Upload preview" /></div>
            :
            <div className="m-4 p-2">
              <React.Fragment>
                <FontAwesomeIcon icon={faCloudUploadAlt} size="3x" />
                <p>{uploadText || 'No Pictures Chosen, Yet!'}</p>
              </React.Fragment>
            </div>}
        </div>
      </div>
      <input ref={uploadInput} id="upload-input" onChange={(event) => readImageInput(event.target, setCurrentPhoto, setUploadPhoto)} accept="image/*" className="d-none" type="file" />
    </React.Fragment>
  )
}